import React, { forwardRef } from "react";
import { bool, func, node, number, oneOf, oneOfType, string } from "prop-types";
import { uncontrollable } from "uncontrollable";

import { CheckboxInput, CheckboxLabel, InputBox, LabelCopy } from "./styled";

/**
 * @deprecated use @streeteasy/design-system/form/CheckboxInput instead
 */
export const Checkbox = forwardRef((props, ref) => {
  const {
    checkboxPosition,
    children,
    isChecked,
    isDisabled,
    label,
    name,
    onChange,
    theme,
    value
  } = props;

  const handleChange = event => {
    const { checked } = event.target;
    onChange(checked, event);
  };

  return (
    <CheckboxLabel
      {...props}
      checkboxPosition={checkboxPosition}
      onChange={() => {}}
    >
      <CheckboxInput
        ref={ref}
        checked={isChecked}
        disabled={isDisabled}
        name={name}
        onChange={handleChange}
        value={value}
      />
      <InputBox checked={isChecked} isDisabled={isDisabled} theme={theme} />
      {label && <LabelCopy>{label}</LabelCopy>}
      {children}
    </CheckboxLabel>
  );
});

Checkbox.displayName = "Checkbox";

Checkbox.defaultProps = {
  checkboxPosition: "top",
  children: null,
  isChecked: false,
  isDisabled: false,
  label: "",
  name: "",
  onChange: () => {},
  theme: "default",
  value: 1
};

Checkbox.propTypes = {
  /** The position of the checkbox relative to the label. */
  checkboxPosition: oneOf(["top", "center", "bottom"]),
  /** Children to be placed within label */
  children: node,
  /** Whether the checkbox is checked or unchecked */
  isChecked: bool,
  /** Whether the checkbox is disabled */
  isDisabled: bool,
  /** If left out, no label will be rendered next to the checkbox */
  label: string,
  /** Name to be attached to the checkbox */
  name: string,
  /**
   * Callback function for when the checkbox is toggled. If provided, this
   * instance's parent is responsible for updating `isChecked` accordingly.
   *
   * @param {bool} checked
   * @param {SyntheticEvent} event
   */
  onChange: func,
  /** Blue-styled checkbox (only blue when checked) */
  theme: oneOf(["classicBlue", "default", "primary", "secondary"]),
  /** Value of the checkbox */
  value: oneOfType([string, number])
};

export default uncontrollable(Checkbox, {
  isChecked: "onChange"
});
